import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import { getDateTimeFromJSONDate } from 'utils/DateUtils.js';
import { updateMember, subscribe, unsubscribe, getUserEmailList, getEmailList, getAuthData, saveAuthData } from 'utils/MemberUtils';
import EmailPreferenceTypes from 'constants/EmailPreferenceTypes';
import MemberFormDefaultMessage from 'constants/MemberFormDefaultMessage';
import MemberForm from 'components/membership/MemberForm';
import Spinner from 'components/shared/spinner';

class Profile extends Component {
  static propTypes = {
    successMsg: PropTypes.string,
    mainErrorMsg: PropTypes.string
  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    successMsg: MemberFormDefaultMessage.UPDATE_PROFILE_SUCCESS,
    mainErrorMsg: MemberFormDefaultMessage.UPDATE_PROFILE_FAIL
  }

  state = {
    preference: [],
    emailList: [],
    submitted: false,
    errorMsgs: [],
    isLoading: false,
  }

  componentDidMount() {
    const authData = getAuthData() || {};
    const { token } = authData;

    if (token) {
      getUserEmailList(token).then(resp => {
        const { data: emailList = [] } = resp;

        const preference = emailList.map(list => {
          const {
            emaillist: {
              id = ''
            } = {}
          } = list;
          return id;
        });

        this.setState({ preference });
      }).catch(error => {
        const {
          data,
          status = 'Error',
          statusText = ''
        } = error;

        this.setState({
          errorMsgs: data || [ `${status} ${statusText}` ]
        });
      });
    }

    getEmailList().then(data => {
      const {
        data: emailList = []
      } = data;
      this.setState({ emailList });
    }).catch(error => {
      const {
        data,
        status = 'Error',
        statusText = ''
      } = error;

      this.setState({
        errorMsgs: data || [ `${status} ${statusText}` ]
      });
    });
  }

  _onSubmit(memberData, preference) {
    const authData = getAuthData() || {};
    const { token = '' } = authData;

    const { preference: previousPreference } = this.state;

    const subscribeList = this._getChangedSubscribeList(preference, previousPreference);
    const unsubscribeList = this._getChangedSubscribeList(previousPreference, preference);

    if (!memberData.password) {
      delete memberData.password;
    }

    this.setState({
      isLoading: true
    });

    updateMember(memberData, token).then(res => {
      saveAuthData({ member: res.member, token });

      unsubscribe(unsubscribeList, token).then(() => {
        subscribe(subscribeList, token).then(() => {
          this.setState({
            submitted: true,
            isLoading: false
          });
        }).catch(error => {
          throw error;
        });
      }).catch(error => {
        throw error;
      });
    }).catch(error => {
      const {
        data,
        status = 'Error',
        statusText = ''
      } = error;
      this.setState({
        errorMsgs: data || [ `${status} ${statusText}` ],
        isLoading: false
      });
    });
  }

  _getChangedSubscribeList(compareList, excludeList) {
    return _.difference(compareList, excludeList).map(item => {
      return {
        emaillist: { id: item },
        emaillisttypes: [EmailPreferenceTypes.HTML]
      };
    });
  }

  _onRetryButtonClick() {
    this.setState({
      errorMsgs: []
    });
  }

  render() {
    const {
      successMsg,
      mainErrorMsg
    } = this.props;

    const authData = getAuthData() || {};
    const { member: memberData = {} } = authData;

    const {
      preference,
      emailList,
      submitted,
      errorMsgs,
      isLoading
    } = this.state;

    const {
      emailaddress: emailAddress = '',
      username = '',
      firstname: firstName = '',
      lastname: lastName = '',
      dateofbirth: dateOfBirth = '',
      address = '',
      city = '',
      state = 0,
      zipcode = '',
      phonenumber: phoneNumber = '',
      receiveoffers: receiveOffers = false,
      receiveannouncements: receiveAnnouncements = false
    } = memberData;

    const birthday = {};

    if (dateOfBirth) {
      const date = getDateTimeFromJSONDate(dateOfBirth);

      birthday.month = date.getMonth() + 1;
      birthday.day = date.getDate();
      birthday.year = date.getFullYear();
    }

    const member = {
      ...birthday,
      emailAddress,
      username,
      firstName,
      lastName,
      dateOfBirth,
      address,
      city,
      state,
      zipcode,
      phoneNumber,
      receiveOffers,
      receiveAnnouncements,
      preference
    };

    if (isLoading) {
      return (
        <div className="FormLoading">
          <Spinner active />
        </div>
      );
    }

    if (submitted) {
      return (
        <div className="Notification Notification--success">
            <div className="Notification-message" dangerouslySetInnerHTML={{__html: successMsg}}></div>
        </div>
      );
    }

    if (errorMsgs.length) {
      return (
        <div className="Notification Notification--error">
          <div className="Notification-message" dangerouslySetInnerHTML={{__html: mainErrorMsg}}></div>
          {
            errorMsgs.map((msg, index) => <div key={index} className="Notification-message">{msg}</div>)
          }
          <div className="Notification-footer">
            <button className="Notification-btn" onClick={() => this._onRetryButtonClick()}>{MemberFormDefaultMessage.TRY_AGAIN}</button>
          </div>
        </div>
      );
    }

    return (
      <MemberForm
        emailList={emailList}
        member={member}
        btnText="update"
        onSubmit={(m, p) => this._onSubmit(m, p)} />
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./app/components/membership/Profile.js